import React, { createContext, useEffect, useState } from 'react'
import { download, green_tick_dark, healthCheckMale, info_icon, logged_in_employees, manage_employee, rightTickIcon, single_add_icon, single_add_icon_white } from '../../assets/images'
import { Breadcrumb, MetricCard } from '../common/atoms'
import { Pagination, Table } from '../common/molecules'
import { employeeDataApi } from '../../services'
import { handleAppError } from '../handlers'
import { useHistory } from 'react-router-dom'
import { manageEmployeeTableSchema } from '../../schemas/table'
import { manage_employee_headers } from '../../constants/tableHeaders'
import { successOrFailureToaster } from '../common/atoms/messages'
import { Tooltip } from 'antd'
import Button from '../common/atoms/DSButton'
import { AddAddressModal, BookAppointmentModal, ChooseAddressModal, ChooseProviderModal, ManageEmployeeModel } from '../modals'
import SearchBar from '../tailwind/molecules/SearchBar'
import { CustomAppointmentDrawer } from '../common/organisms'
import { SALES_ROLE } from '../../constants/overview'
import AppointmentBookedModal from '../modals/AppointmentBookedModal'
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles'
export const ManageEmployeeContext = createContext()

const ManageEmployeesPage = () => {
  const [state, setState] = useState({employees : [], loading : true , searchValue : '' , metricData : [], openModel : false, statusVar : '' , employeeID : '', employeeName : '' , selectedEmpID: null, selectedEmpMobileNumber: null,selectedIsdCode: '+91' , selectedEmpEmail: null, selectedEmpGender: null, selectedEmpDOB: null, showSearchResult : false , ShowFilterModel : false, radioStatus : '', showBookAppointmentModal : false,
  selectedPackageID: null, selectedPackageName: null, selectedPackageType: '',showChooseAddressModal: false, showAddAddressModal: false, newAddress: null, showChooseProviderModal: false, isNewAddress: false, step: 0, 
  selectedDate: null, selectedTime: null, selectedProvider: null, bookingID: null, uniqueID: null, line1: null})

  const [paginationData, setPaginationData] = useState({ total_pages : 0,cur_page: 0, total_results: 0 })
  const history = useHistory()

  const setSubState =(newState) =>{
    setState(prevState => {return {...prevState , ...newState}})
  }

  useEffect(() => {
    searchAction()
    employeeDataApi.fetch_manage_employee_metric_card({} , 
      (res) =>{
        let data = res.data 
        setSubState({metricData : data, loading :false})
      },
      (error) => handleAppError(error)
      )
  }, [])

  const editHandler = (data) => {
    history.push('/manage-employee/edit', { data: JSON.stringify(data) });
  };

  const onToggleHandler = (value, id) =>{
    let EmployeeId =  id || state.employeeID
    let status = value || state.statusVar
    if(status !== 'Active') {   
      employeeDataApi.delete({id: EmployeeId}, 
      (_)=>{
        let newData = state.employees.map((item) =>{
          if(item.id === EmployeeId)
            item['customer_status'] = status
          return item
        })
        setSubState({employees : newData})
        successOrFailureToaster({message: 'Employee has been succesfully deactivated' })
      },
      (error) => handleAppError(error)
      )
     }
     else{
      employeeDataApi.activate_employees({id: EmployeeId}, 
        (_)=>{
          let newData = state.employees.map((item) =>{
            if(item.id === EmployeeId)
              item['customer_status'] = status
            return item
          })
          setSubState({employees : newData})
          successOrFailureToaster({message: 'Employee has been succesfully activated' })
        },
        (error) => handleAppError(error)
        )
     }
    setSubState({openModel : false})
  }

  const closeModel = (e, id, name) =>{
    let value = e.value ? 'Active' : 'Inactive'
    setSubState ({openModel : !state.openModel, employeeID : id, employeeName : name, statusVar : value})
  }

  const openBookAppointmentModal = (e,data) =>{
    setSubState({showBookAppointmentModal: true, selectedEmpID : data.id, employeeName: data.name, selectedEmpMobileNumber : data.mobile_number,selectedIsdCode: data.isd_code , selectedEmpEmail : data.email, selectedEmpGender : data.gender, selectedEmpDOB: data.date_of_birth, step: 1})
  }

  const onSearchSuccess = (result, searchResult, perPage = 0) => {
    let data = result.meta.customers || []
    data = data.length > 0 ? data : null;
    let totalResult =  result.meta.totalemloyees
    setSubState({employees : data , showSearchResult: searchResult });
    setPaginationData({ total_pages: Math.ceil(totalResult / 10), cur_page: perPage, total_results : totalResult })
  }; 

  const searchAction =  async (value = '' , perPage = 0) => {
    setSubState({ searchValue : value})
    let searchResult = (!value) ? false : true
    const options = { params: {  page : perPage + 1 , q: value.trim()} };
    await employeeDataApi.search_employees(
      options,
      (res) => {
        onSearchSuccess(res.data, searchResult, perPage);
      },
      (error) => { 
        handleAppError(error)
        setSubState({loading : false})
      }
    );
  };

  const BookAppointmentHandler = (mobileNumber, packageID, packageName, packageType,isdCode) => {
    console.log(isdCode)
    setSubState({ selectedEmpMobileNumber: mobileNumber, selectedPackageID: packageID, selectedPackageName: packageName, selectedPackageType: packageType , selectedIsdCode: isdCode})
    setSubState({ step:2 })
  }

  const chooseAddressHandler = (value, text) => {
    switch(text){
      case 'new-address':
        setSubState({ newAddress: value, latitude: value.latitude, longitude: value.longitude, isNewAddress: true});
        setSubState({ step: 3 })
        break;
      case 'existing-address':
        setSubState({ existingAddress: value, latitude: value.latitude, longitude: value.longitude, isNewAddress: false, line1: null });
        setSubState({ step: 4 })
    }
  }

  const addAddressHandler = () =>{
    setSubState({ step: 4 })
  }

  const addLine1 = (value) =>{
    setSubState({line1: value})
  }

  const renderBooking = () => {
    return(
      <CustomAppointmentDrawer 
        title={ getTitle() }
        handleBack={ () => handleBack( getBackText() ) }
        handleCancel={ () => handleCancel() }
        body={ getBody() }
      />
      )
  }

  const getTitle = () => {
    let step = state.step;
    switch(step){
      case 1:
        return 'Book appointment';
        break;
      case 2:
        return 'Choose address';
        break;
      case 3: 
        return 'Save new address';
        break;
      case 4:
        return 'Choose provider';
        break;
      case 5:
        return 'Appointment booked'
    }
  }

  const getBackText = () => {
    let step = state.step;
    switch(step){
      case 1:
        return 'book-appointment';
        break;
      case 2:
        return 'choose-address';
        break;
      case 3: 
        return 'add-address';
        break;
      case 4:
        return 'choose-provider';
    }
  }

  const getBody = () =>{
    let step = state.step;
    switch(step){      
      case 1:
        return <BookAppointmentModal 
        visible={state.showBookAppointmentModal}
        employeeID={state.selectedEmpID}
        employeeEmail={state.selectedEmpEmail}
        employeeName={state.employeeName}
        employeeMobileNumber={state.selectedEmpMobileNumber}
        employeeGender={state.selectedEmpGender}
        employeeisdCode={state.selectedIsdCode}
        employeeDOB={state.selectedEmpDOB}
        BookAppointmentHandler={BookAppointmentHandler}
        />;
        break;
      case 2:
        return <ChooseAddressModal 
        visible={state.showChooseAddressModal}
        employeeID={state.selectedEmpID}
        chooseAddressHandler={chooseAddressHandler}
        />
        break;
      case 3:
        return <AddAddressModal
        newAddress={state.newAddress}
        employeeID={state.selectedEmpID}
        changeHandler={()=>handleBack('add-address')}
        addAddressHandler={addAddressHandler}
        addLine1={addLine1}
        />;
        break;
      case 4:
        return <ChooseProviderModal
        packageID={state.selectedPackageID}
        packageType={state.selectedPackageType}
        employeeID={state.selectedEmpID}
        employeeName={state.employeeName}
        changeHandler={()=>handleBack('choose-provider')}
        createHandler={createHandler}
        address={state.isNewAddress ? state.newAddress : state.existingAddress}
        line1={state.line1}
        mobileNumber={state.selectedEmpMobileNumber}
        isdCode={state.selectedIsdCode}
        failureHandler={failureHandler}
        />;
        break;
      case 5:
        return <AppointmentBookedModal
        packageName={state.selectedPackageName}
        provider={state.selectedProvider}
        employeeName={state.employeeName}
        date={state.selectedDate}
        time={state.selectedTime}
        uniqueID={state.uniqueID}
        handleClose={handleCancel}
        failureHandler={failureHandler}
        />;
    }
  }

  const handleBack = (text) =>{
    switch(text){
      case 'book-appointment':
        setSubState({showBookAppointmentModal: false, step: 0});
        break;
      case 'choose-address':
        setSubState({ step: 1 })
        break;
      case 'add-address':
        setSubState({ step: 2 })
        break;
      case 'choose-provider':
        setSubState({ step: 2 })
        break;
    }
  }

  const createHandler = (provider, date, time, bookingID, uniqueID) => {
    setSubState({ selectedDate: date, selectedTime: time, selectedProvider: provider, bookingID: bookingID, uniqueID: uniqueID })
    setSubState({ step: 5 })
  }

  const failureHandler = () => {
    setSubState({showBookAppointmentModal: false, step: 0})
  }

  const handleCancel = () => {
    setSubState({showBookAppointmentModal: false, step: 0})
    searchAction()
  }

  const onImgHandler = () => {
    setSubState({ ShowFilterModel : !state.ShowFilterModel})
  }       
  const onCancel  = () =>{
    setSubState({ ShowFilterModel : false})
  }          
  const filterSelectionHandler = (event, value, perPage = 0) =>{ 
    if (value === 'clear') {
       setSubState({radioStatus : ''})
       searchAction()
       setSubState({ ShowFilterModel : false})
       return
    }
    else
    setSubState({radioStatus : value})
    let isSelected = event.checked
    if(isSelected || value){
      let status  = value === 'Active'  ? true : false 
      const options = { params: {  status : status, page : perPage + 1} };
      employeeDataApi.search_employees(
        options,
        (res) => {
          onSearchSuccess(res.data, false, perPage );
        },
        (error) => {
          handleAppError(error)
          setSubState({loading : false})
        }  
      );
    }
  }
  const navigateToPage =  (page ) =>{
    setPaginationData(prevState => { return {...prevState, cur_page: page } })
    if(!state.radioStatus) state.searchValue ? searchAction( state.searchValue , page) : searchAction( '', page)
    else filterSelectionHandler('',state.radioStatus, page)
  }

  const headers = [...manage_employee_headers(state.showSearchResult, state.ShowFilterModel, onImgHandler)]

  const downloadList = ()  => {
    employeeDataApi.download_employee_list({}, 
      (resp)=>{
        successOrFailureToaster({ message: 'The requested data will be sent to you on your email id within an hour' }) 
      },
      (error) =>{ 
          handleAppError(error)
        } 
      )  
    }
  return (
    <React.Fragment >
      <div className='flex flex-row justify-between content-center'>
        <div className='flex flex-col text-left align-top' style={{height :'44px'}}>
          <Breadcrumb list={[{ text: 'Manage Employees', link: '/manage-employee' }, { text: 'Employee list', link: '#' }]} classes='mb-1'/>
          <p className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Employees list</p>
        </div>          
        <div className='flex flex-row'>
          <button className={joinButtonClasses(dsButtonSecondary, 'mr-3 h-11 px-6', SALES_ROLE === 'sales' && 'cursor-not-allowed')} disabled={SALES_ROLE === "sales"} type='button' onClick={(e) => downloadList(e)}>
            <img src={download} alt='icon' className='mr-1' style={{width: '20px'}}/>
              Download Employee list
          </button>          
          <button className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')} type='button' onClick={() => history.push('/manage-employee/add-employee')}>
            <img src={single_add_icon_white} alt='icon' className='mr-1' style={{width: '20px'}}/>
              Add employee
          </button>
        </div> 
     </div>    
        <p className='text-gray-500 text-xs leading-3 tracking-widest font-semibold mt-6'>OVERVIEW</p>
        <div className='flex flex-row justify-between mt-3'> 
         <MetricCard
            title={<span className='flex flex-row text-gray-600'>Total employees added<Tooltip placement='top' title='The total no of employees registered on the ekincare platform.'><img className='w-4 h-4 ml-2' src={info_icon}/></Tooltip></span>}
            loading={state.loading}
            loaderHeight={120}
            headerClasses='py-5 px-4'
            svgsrc={healthCheckMale} 
            btnText={false}
            titleClasses='text-gray-500 leading-4 block'
            metricClasses='mt-4  xl:mt-4'
            classes='w-1/3 mr-4 h-28'
            metricValue={<p><span className='font-semibold text-3xl text-gray-700 mr-3'>{state.metricData.total_customer_count ?? 0}</span>employees</p>}
         />
          <MetricCard
            title={<span className='flex flex-row text-gray-600'>Total active employees<Tooltip placement='top' title='Total no of employees who are active as of today. (Total registered emp - Deactivated emp)'><img className='w-4 h-4 ml-2' src={info_icon}/></Tooltip></span>}
            svgsrc={manage_employee}
            loading={state.loading} 
            headerClasses='py-5 px-4'
            loaderHeight={120}
            metricClasses='mt-4  xl:mt-4'
            classes= 'w-1/3 mr-4 h-28'
            titleClasses='text-gray-500 leading-4 block'
            metricValue={<p><span className='font-semibold text-3xl text-gray-700 mr-3'>{state.metricData.active_customers_count ?? 0}</span>employees</p>}
         />
          <MetricCard
            title={<span className='flex flex-row text-gray-600'>Total onboarded employees<Tooltip placement='top' title='The total no of employees who has logged in atleast once in their life time on ekincare web/app.' ><img className='w-4 h-4 ml-2' src={info_icon}/></Tooltip></span>}
            svgsrc={logged_in_employees} 
            loading={state.loading}
            loaderHeight={120}
            headerClasses='py-5 px-4'
            metricClasses='mt-4  xl:mt-4'
            classes='w-1/3 h-28'
            titleClasses='text-gray-500 leading-4 block'
            metricValue={<p><span className='font-semibold text-3xl text-gray-700 mr-3'>{state.metricData.active_users_session_count ?? 0 }</span>employees</p>}
            />   
      </div>  
        <SearchBar 
          classes='mb-4 h-12 mt-8 mb-6'
          placeholder='Search by email id, phone number, and employee code'
          inputClasses='px-3 rounded-md pt-4 pb-3 pl-10 text-base'
          handler={searchAction}
          CloseIconHandler={() => {
            setSubState({radioStatus : ''})
            searchAction()
          }}
        />
      {state.showSearchResult &&  <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3'>SEARCH RESULTS</p>}
      <ManageEmployeeContext.Provider value={[onCancel,filterSelectionHandler, state.radioStatus]} >
        <Table
          loading={state.loading}
          data ={state.employees ?? []}
          tableClasses='alternate_gray200_color'
          classes='rounded-md'      
          headers={headers}
          tableschema={manageEmployeeTableSchema}
          history={history}
          moveToEditEmployee={editHandler}
          openModel= {closeModel}
          role={SALES_ROLE}
          openBookAppointmentModal={openBookAppointmentModal}
        />
      </ManageEmployeeContext.Provider>
      { paginationData.total_results  > 10 &&
        <Pagination
          totalpages={paginationData.total_pages}
          totalresults={paginationData.total_results}
          curpage={paginationData.cur_page}
          handler={navigateToPage}
          activeText='bg-blue-100'
          border = 'border-gray-200 border'
          marginTop='mt-3'
        />
      }
      {state.openModel  && 
        <ManageEmployeeModel  
          visible={state.openModel} 
          title={`Are you sure you want to ${state.statusVar === 'Active' ?  "activate" : 'deactivate'} employee "${state.employeeName}" ?`} 
          description={state.statusVar === 'Active' ?  "Activating the employee will provide them access to ekincare app" : 'Deactivating the employee will revoke the access to ekincare app'}
          onCancel={() => {
          setSubState({openModel : false}) 
          } } 
          icon={state.statusVar === 'Active' &&  green_tick_dark}
          handler={() => onToggleHandler()}
        />
      }

      { state.showBookAppointmentModal && renderBooking() }
    </React.Fragment>
  )
}

export default ManageEmployeesPage
